module.exports = __webpack_public_path__ + "static/media/procesos9.984b39d0.jpg";